export default function (app) {
	app.directive('ajaxLoader', ['$http', function ($http) {
		return {
			link: function (scope) {

				scope.$watch(function () {
					return $http.pendingRequests.length;
				}, function (newVal) {
					if (newVal > 0) {
						scope.showLoading = true;
					} else {
						scope.showLoading = false;
					}
				});
			}
		};

	}]);
};
